import type { DailyAggregation } from './types';

export function humanize(value: string): string {
  const words = value.replace(/^\$\./, '').replace(/\[\]/g, '').replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[._-]+/g, ' ').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export const aggregationLabels: Record<DailyAggregation, string> = {
  average: 'Daily average', total: 'Daily total', minimum: 'Daily minimum', maximum: 'Daily maximum',
};

export const formatNumber = (value: number) => value.toLocaleString(undefined, { maximumFractionDigits: 2 });
export const shortDate = (date: string) => new Date(`${date.slice(0, 10)}T12:00:00Z`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' });
